import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { WebsocketService } from 'src/app/websocket';
import { LanguageService, AuthService, ApiUsersService, PermissionService, ApiOrganizationsService, NotificationService, ApiNotificationsService, FilesService, DialogModalService } from 'src/app/services';
import { ListParams, PaginationInput, PaginationPageEvent, Res, UserInfo, NotificationData, AttributeModel, ConditionOperators, LangObj, ReferenceParams } from 'src/app/models';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiSettingsService } from 'src/app/services/api-settings.service';
import { ViewFileDataComponent } from '../../dialog';
import { SvgIconRegistryService } from 'angular-svg-icon';
import { PaginationService } from 'src/app/services/pagination.service';

@Component({
  selector: 'app-closed-page-layout',
  templateUrl: './closed-page-layout.component.html',
  styleUrls: ['./closed-page-layout.component.css']
})
export class ClosedPageLayoutComponent implements OnInit {
  private readonly moduleByRootRoute: { [key: string]: string } = {
    products: 'PRODUCTS',
    files: 'FILES',
    settings: 'SETTINGS',
    organizations: 'ORGANIZATIONS',
    users: 'USERS',
    notifications: 'NOTIFICATIONS',
    import: 'IMPORTS',
    presets: 'PRESETS'
  };

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  user: UserInfo;
  currentRoute: string = '';
  organizations: any[];
  languages: LangObj[];
  organization: any;
  notification: any;
  notifications: NotificationData[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  avatar: any;
  hidden: boolean;
  clean: boolean;
  status: boolean;
  searchStatus: boolean = true;
  searchRes: any[] = [];
  fileListData: File[] = [];
  splitPattern: any = new RegExp('[\n\\s+$,;]');
  fileAttributes: AttributeModel[] = [
    {
      id: 'name',
      name: 'Наименование'
    },
    {
      id: 'binding_value',
      name: 'Штрих-код'
    }
  ]

  fileDateOperators: ConditionOperators[] = [
    {
      id: 'IN',
      name: 'Равно'
    }
  ]

  form: UntypedFormGroup = this.fb.group({
    search: ['']
  })


  fileSearchform: UntypedFormGroup = this.fb.group({
    attribute_id: ['name', Validators.required],
    operator: ['SIMILAR TO', Validators.required],
    values: [null, Validators.required],
  })

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService,
    private languageService: LanguageService,
    private apiUsers: ApiUsersService,
    private apiOrganozations: ApiOrganizationsService,
    private apiNotifications: ApiNotificationsService,
    public permissionService: PermissionService,
    private wsService: WebsocketService,
    private notificationService: NotificationService,
    private fileService: FilesService,
    private apiSettings: ApiSettingsService,
    private apiFileService: FilesService,
    private dialogModal: DialogModalService,
    private iconReg: SvgIconRegistryService,
    private paginationService: PaginationService
  ) {}

  onSidebarNavClick(route: string, event: MouseEvent): void {
    console.log('[NAVBAR_CLICK]', {
      route,
      currentRoute: this.currentRoute,
      hidden: this.hidden,
      sidebarCollapsed: this.status,
      isLoggedIn: this.authService.isLoggedIn(),
      hasUser: !!this.user,
      userRoleIds: this.user && this.user.roles ? this.user.roles.map(val => val.id) : []
    });
    this.hidden = false;
    event.stopPropagation();
  }


  ngOnInit(): void {

    this.language = this.languageService.getLanguage();
    this.languages = this.languageService.languagesObj;
    this.currentRoute = this.router.url;
    this.syncPermissionsForRoute(this.currentRoute);

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
        this.languages = this.languageService.languagesObj;
      })
    );

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.permissionService.currentModule = 'CLOSED_PAGES';

    this.setStateSidebar();

    if (this.permissionService.check('REFERENCES_DEFAULT_SETTINGS')) {

      this.apiSettings.getSettings();
    }


    this.subscriptions.add(
      this.apiUsers.listenerUserInfo().subscribe((value: UserInfo) => {

        this.user = value;

        if (this.user.avatar_pic) {

          this.getImageContent(this.user.avatar_pic);
        }
      })
    );

    this.subscriptions.add(
      this.router.events.subscribe((val) => {

        if (val instanceof NavigationStart) {
          console.log('[ROUTER_EVENT] NavigationStart', val.url);
          this.currentRoute = val.url;
          this.progressRef.start();
        }

        if (val instanceof NavigationEnd) {

          this.currentRoute = val.url;
          this.syncPermissionsForRoute(this.currentRoute);
          this.progressRef.complete();

          console.log('[ROUTER_EVENT] NavigationEnd', this.currentRoute);

        }

        if (val instanceof NavigationCancel) {
          console.warn('[ROUTER_EVENT] NavigationCancel', val.url, val.reason);
          this.progressRef.complete();
        }

        if (val instanceof NavigationError) {
          console.error('[ROUTER_EVENT] NavigationError', val.url, val.error);
          this.progressRef.complete();
        }
      })
    );

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    // WS
    // setTimeout - временная проверка работы WebSocket'а на получение и отправку сообщений
    // setTimeout(()=>{
    //   this.wsService.send('notification', "{ title: 'Notification', content: 'message text...' }");
    //   console.log('send: ', "{ title: 'Notification', content: 'message text...' }");
    // }, 3000)

    // получение сообщений по каналу notification
    this.subscriptions.add(
      this.wsService.on<any>('notification').subscribe((data: any) => {

        console.log('Notification: New message', data);
        this.notification = data;
        this.notificationService.show('notify', this.notification.message);
        this.getNotificationList();
      })
    );

    this.subscriptions.add(
      this.apiNotifications.listenerNotificationRead().subscribe(val => {

        if (val) {

          this.getNotificationList();
        }
      })
    );

    this.form.get('search').valueChanges.subscribe(val => {

      if (val.length >= 4) {

        setTimeout(() => this.onGlobalSearch(val, 'products'), 300)

      } else {
        this.searchRes = [];
        this.searchStatus = true;
      }
    });

    this.fileSearchform.get('values').valueChanges.subscribe(val => {

      console.log("FILTER VAL: ", val);

      if (val.length > 3) {

        // this.getFilterData(val);

        setTimeout(() => this.onGlobalSearch(val, 'files'), 300)
      }
    });

    this.subscriptions.add(
      this.apiFileService.listenerFileListData().subscribe(val => {

        if (val && val.length > 0) {

          val.sort((a, b) => a.name.localeCompare(b.name));

          console.log("REVERT FILTER DATA: ", val);

          this.fileListData = val;

          this.searchStatus = false;

        }

      })
    );

    this.getNotificationList();
    this.getUser();
    this.getOrganizations();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   * @param event 
   * @returns 
   */
  numberOnly(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57) && this.fileSearchform.get('attribute_id').value == 'binding_value') {
      return false;
    }
    return true;

  }

  /**
   * 
   */
  getFilterData(val) {

    let data = {

      attribute_id: 'name',
      operator: 'SIMILAR TO',
      values: [val],

    }

    this.apiFileService.setFilterData(data);
  }

  /**
 * 
 * @param value
 */
  selectLanguage(value: string): void {

    this.languageService.selectLanguage(value);
  }

  /**
   * 
   * @param serachValue 
   */
  onGlobalSearch(serachValue: string, type: string): any {

    if (serachValue == "") {
      this.searchRes = [];
      return
    }

    let data = {
      filter: {
        search_str: serachValue,
        type: type
      }
    }

    this.searchStatus = true;

    this.subscriptions.add(
      this.apiOrganozations.onSearch(data).subscribe((response: Res) => {
        console.log('[RESPONSE] globalSearch result: ', response);

        // let filteredData:any[] = [];

        if (response != null && response.result != null) {

          type == 'products' ? this.searchRes = response.result.list : this.fileListData = response.result.list;

          this.searchStatus = false;
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  @HostListener('document:click')
  documentClick(): void {

    this.searchRes = [];
    this.searchStatus = true;
  }

  /**
   * 
   * @returns boolean
   */
  visibility(): boolean {

    if (this.currentRoute == '/users/profile') {

      return true;
    }
    return false;
  }


  /**
   * 
   * @param menuItem string
   * @returns boolean
   */
  checkActiveMenu(menuItem: string): boolean {

    let urlItems: string[] = this.currentRoute.split('/');

    if (menuItem && urlItems.length > 1) {

      if (urlItems[1].toLowerCase() == menuItem.toLowerCase()) {

        return true;
      }
    }

    return false;
  }


  /**
   * 
   */
  logout(): void {

    this.authService.logout(this.progressRef);
  }


  /**
   * 
   */
  getUser(): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiUsers.info().subscribe((response: Res) => {
        console.log('[RESPONSE] getUserInfo: ', response);


        this.user = { ...response.result };
        this.apiUsers.setUserInfo(this.user);

        if (this.user.avatar_pic) {

          this.getImageContent(this.user.avatar_pic);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * Временное решение, придумать что поинтереснее
   */
  checkUserRole(){
    if (!this.user || !this.user.roles) {
      return false;
    }
    return this.user.roles.find(val => val.id == '344bb204-2907-4576-b8ce-1e230d790b68') ? false : true;
  }

  private syncPermissionsForRoute(url: string): void {
    const rootSegment = (url || '').split('?')[0].split('/')[1];
    const moduleName = this.moduleByRootRoute[rootSegment];
    if (!moduleName) {
      return;
    }
    this.permissionService.currentModule = moduleName;
    this.permissionService.getActions(moduleName);
    console.log('[PERMISSIONS_SYNC] route->module', { url, moduleName });
  }


  /**
   * 
   * @param product Product
   */
  getImageContent(file_id: any): void {

    this.subscriptions.add(
      this.fileService.getImageContent(file_id).subscribe((response: any) => {

        if (response != null) {

          this.avatar = response.result;
        }
      })
    );
  }


  /**
   * 
   */
  getOrganizations(): void {

    let data = {
      ref_name: 'user_orgs',
      filter: {}
    }

    this.subscriptions.add(
      this.apiOrganozations.getReferences(data, data.ref_name).subscribe((response: Res) => {
        console.log('[RESPONSE] getOrganizations: ', response);

        if (response != null && response.result != null) {

          this.organizations = response.result;

          if (this.organizations.length > 0) {

            let res = this.organizations.filter(val => val.is_default_org == true);

            if (res.length > 0) {

              this.organization = res[0];
              this.apiOrganozations.setDataCurrentOrganization(res[0]);
            }
          }
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
   * 
   */
  getNotificationList(): void {

    this.progressRef.start();
    this.notifications = [];

    let params: ReferenceParams = {
      ref_name: 'notification_types',
      filter: {

      }
    }

    this.apiNotifications.getReferences(params, 'notifications').subscribe((response: Res) => {
      console.log("[RESPONSE] getListNotifications: ", response)

      if (response != null && response.result != null) {
       
        this.notifications = response.result;
      }

      this.progressRef.complete();
    },
      error => {
        this.progressRef.complete();
      });

  }


  /**
   * 
   */
  // getNotificationList(): void {

  //   this.progressRef.start();
  //   this.notifications = [];

  //   this.setListParams();

  //   this.apiNotifications.getListNotifications(this.listParams).subscribe((response: Res) => {
  //     console.log("[RESPONSE] getListNotifications: ", response)

  //     if (response != null) {

  //       //this.notifications = response.result.list;

  //       if (response.result != null) {

  //         for (let item of response.result.list) {

  //           item.notification_content = JSON.parse(item.notification_content);
  //           item.notification_content = item.notification_content.content.message;
  //           this.notifications.push(item);
  //         }

  //         this.paginationInput = {
  //           count: response.result.count,
  //           numberOfPages: response.result.numberOfPages,
  //           currentPage: this.listParams.pageNumber,
  //           size: this.listParams.countOnPage
  //         }

  //       }
  //     }

  //     this.progressRef.complete();
  //   },
  //     error => {
  //       this.progressRef.complete();
  //     });
  // }

  // Pagination

  /**
   * 
   * @param event PaginationPageEvent
   */
    pageEvent(event: PaginationPageEvent): void {
      
      this.paginationService.setPaginationData(event);


      // this.paginationOutput = event;
  
      // this.filterConditionData.length == 0 && this.categoryCondition.value.length == 0 ? this.getList() : this.getList(), this.paginationOutput.pageNumber = 1;
  
    }


  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        name: '',
        sort: 'NEW'
      },
      object: 'notifications',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
   * 
   */
  getProfile(fileId: string) {

    let data = {
      file_id: fileId
    }

    this.dialogModal.open(data, ViewFileDataComponent).then(
      (result) => {

        if (result) {

        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   * @param orgId string
   */
  changeDefaultOrganization(orgId: string): void {

    let data = {
      org_id: orgId
    }

    this.subscriptions.add(
      this.apiOrganozations.changeDefaultOrganization(data).subscribe((response: Res) => {
        console.log('[RESPONSE] changeDefaultOrganization: ', response);

        // дальнейшие действия ...
        window.location.reload(); // <-- временное решение

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
    *
    * @param serachValue string
   */
  onClear(): any {

    if (this.currentRoute == '/files') {

      this.fileSearchform.get('values').setValue("");

      this.fileListData = [];
    }

    if (this.currentRoute == '/products') {

      this.form.get('search').setValue("");;

      this.searchRes = [];
    }

  }

  /**
   * 
   */
  toggleSidebar(s: boolean = null): void {

    this.status = (s == null) ? !this.status : s;
    this.setStateSidebarInLocalStorage();
  }


  /**
   * 
   */
  setStateSidebarInLocalStorage(): void {

    localStorage.setItem('state_sidebar', this.status ? '1' : '0');
  }


  /**
   * 
   */
  setStateSidebar(): void {

    let stateSidebar: string = localStorage.getItem('state_sidebar');

    if (stateSidebar) {

      this.status = stateSidebar == '1' ? true : false;
      return;
    }

    this.status = false;
    this.setStateSidebarInLocalStorage();
  }
}